import * as React from 'react'

import { IEnhancedLocation } from '../../../common/reducers/reactRouterLocation'

interface IProps {
  location: IEnhancedLocation
}

class RouteHashScroll extends React.Component<IProps> {
  public componentDidUpdate() {
    const { hash } = this.props.location
    if (hash) {
      const element = document.querySelector(hash)
      if (element) {
        element.scrollIntoView()
      }
    }
  }

  public render() {
    return this.props.children
  }
}

export default RouteHashScroll
